import { Params } from '@angular/router/src/shared';

function parseHashString(queryString: string) {
    let result = {};

    let vars = queryString.split('&');
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    return result;
}

/**
 * Parsing MCI authentication secret / legacy sso / IBHash.
 *
 * Example: #IB-Hash-v2=xxx
 *
 * @param {string} hash - url hash / fragment
 * @return {any} hash object with parsed hash parameters
 */
export function parseHash(hash: string): Params {
    if (!hash  ||  hash.indexOf('#') < 0) {
        return {};
    }

    let query = hash.substring(hash.indexOf('#') + 1);
    return parseHashString(query);

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/helper/hash-parser.ts